import Vue from 'vue'

let beamObserver = null

function getBeamObserver() {
  if (beamObserver) return beamObserver
  if (typeof window === 'undefined' || !('IntersectionObserver' in window)) {
    return null
  }
  beamObserver = new IntersectionObserver(
    entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('beam-lit')
          beamObserver.unobserve(entry.target)
        }
      })
    },
    { threshold: 0.5 }
  )
  return beamObserver
}

export default function (context) {
  Vue.directive('beam', {
    inserted(el) {
      const observer = getBeamObserver()
      if (!observer) return
      el.classList.add('beam-init')
      observer.observe(el)
    },
    unbind(el) {
      if (beamObserver) beamObserver.unobserve(el)
    },
  })
  Vue.directive('can', function (el, binding) {
    if (
      context.app.store.$auth.user?.user_type?.identifier &&
      binding.value === context.app.store.$auth.user.user_type.identifier
    ) {
      return true
    } else {
      return false
    }
  })
  Vue.directive('text-linkify', {
    bind(el, binding) {
      import('dompurify').then(({ default: DOMPurify }) => {
        const sanitizedContent = DOMPurify.sanitize(binding.value)

        const regex = /(https?:\/\/[^\s/$.?#].[^\s]*)/gm

        el.innerHTML = sanitizedContent.replace(regex, match => {
          return `<a href="${match}" target="_blank" rel="noopener noreferrer">${match}</a>`
        })
      })
    },
  })
}
